export default class Airport {
  id = ''
  name = ''
  city = ''
  country = {}
  geoCoordinates = {}
}
